export default __webpack_public_path__ + "static/media/circleFullTp.bfb6bda5.svg";